/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Platform } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { pd } from '@airasia-rn/ui';

const isWeb = Platform.OS === 'web';

export const styles = StyleSheet.create((pd) => ({
  page: {
    flex: 1,
    backgroundColor: pd.sys.colour.bg_primary.toString(),
  },
  container: {
    flex: 1,
    backgroundColor: pd.sys.colour.bg_primary.toString(),
  },
  flatList: {
    ...(isWeb
      ? ({
          overflow: 'visible',
          overflowX: 'visible',
          overflowY: 'visible',
          transition: 'opacity 0.2s ease-in-out',
        } as any)
      : {}),
  },
  dimmedContent: {
    opacity: 0.7,
  },
  blockSpacing: {
    marginBottom: {
      xs: isWeb ? pd.ref.space.spacing40.px : pd.ref.space.spacing30.px,
      md: pd.ref.space.spacing50.px,
    },
  },
  center: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  listContent: {
    ...(isWeb ? { flexGrow: 1 } : {}),
  },
  webListContent: {
    flexGrow: 1,
    paddingBottom: 40,
    paddingTop: {
      xs: pd.ref.space.spacing50.px,
      md: 0,
    },
  },
  section: {
    width: '100%',
    zIndex: 1,
  },
  webHeader: {
    height: 60,
    backgroundColor: pd.sys.colour.sentiment_low.toString(),
    justifyContent: 'center',
    zIndex: 10,
  },
  mobileHeader: {
    height: 56,
    backgroundColor: pd.sys.colour.container_none.toString(),
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: pd.ref.space.spacing30.px,
  },
  footerWrapper: {
    flex: 1,
    justifyContent: 'flex-end',
    marginTop: 'auto',
  },
  webFooter: {
    height: 150,
    backgroundColor: pd.sys.colour.bg_primary.toString(),
    width: '100%',
  },
  notificationbanner: {
    paddingHorizontal: pd.ref.space.spacing40.px,
  },
  primeAds: {
    marginHorizontal: pd.ref.space.spacing40.px,
    alignItems: 'center',
  },
  recommendationStickyHeader: {
    backgroundColor: pd.sys.colour.bg_primary.toString(),
    zIndex: 20,
  },
  offlineRecommendation: {
    minHeight: 350,
    paddingVertical: 24,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    width: '100%',
  },
  searchWidgetFullscreen: {
    flex: 1,
  },
  contentArea: {
    flex: 1,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  offlineBanner: {
    position: 'absolute',
    bottom: 40,
    left: 0,
    right: 0,
    zIndex: 100,
    marginHorizontal: pd.ref.space.spacing40.px,
  },
  quickActionsBar: {
    ...(Platform.select({
      web: { position: 'fixed' as any },
      default: { position: 'absolute' },
    }) as object),
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 101,
  },
}));

export default styles;
